export const inputSize = 160;
export const maxDescriptorDistance = 0.45;